module.exports = __webpack_public_path__ + "fonts/MyriadPro-Light.c0098d8.ttf";